<template>
  <div class="input-group input-group-sm filter-field-text-group">
    <select
      :value="filterOperator"
      class="form-select form-select-sm filter-op-select"
      @change="onFilterOperatorChange($event.target.value)"
    >
      <option value="=">{{ $t('Equal to') }}</option>
      <option value="regex">{{ $t('Contains') }}</option>
      <option value="startswith">{{ $t('Starts with') }}</option>
      <option value="endswith">{{ $t('Ends with') }}</option>
      <option value="!=">{{ $t('Different from') }}</option>
      <option value=">">{{ $t('Greater than') }}</option>
      <option value="<">{{ $t('Less than') }}</option>
      <option value=">=">{{ $t('Greater than or equal to') }}</option>
      <option value="<=">{{ $t('Less than or equal to') }}</option>
      <option value="is_null">{{ $t('Is empty') }}</option>
      <option value="is_not_null">{{ $t('Is not empty') }}</option>
    </select>
    <input
      v-if="field.type === 'string' || field.type === 'text' || field.type === 'varchar' || field.type === 'char' || field.type === 'autoincrement' || field.type === 'email'"
      :value="displayValue"
      :id="computedFieldId"
      class="form-control form-control-sm"
      :placeholder="placeholder"
      :readonly="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
      type="text"
      @input="onFilterValueChange($event.target.value)"
      @blur="onFilterValueChange($event.target.value)"
    />
    <textarea
      v-else-if="field.type === 'textarea'"
      :value="displayValue"
      :id="computedFieldId"
      class="form-control form-control-sm"
      :placeholder="placeholder"
      :readonly="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
      rows="4"
      cols="50"
      @input="onFilterValueChange($event.target.value)"
      @blur="onFilterValueChange($event.target.value)"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "FilterFieldText",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      return "";
    },
    placeholder() {
      return this.field.label || this.field.key || "";
    },
    computedFieldId() {
      return this.fieldId || `filter-text-${this.field.key}`;
    },
  },
  methods: {
    onFilterOperatorChange(operator) {
      this.$emit("filter-operator-change", operator);
    },
    onFilterValueChange(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
  align-items: stretch;
}

.filter-op-select {
  flex: 0 0 auto;
  width: auto;
  min-width: 5.75rem;
  max-width: 8.75rem;
}
</style>

